<script setup lang="ts">
const props = defineProps<{
  data: EducationPage
  entries: Education[]
}>()
</script>

<template>
  <div>
    <layout-page-heading
      :title="props.data.title"
      :sub-title="props.data?.subTitle"
    />

    <div
      v-if="props.data?.description"
      class="container-d px-1 mb-6"
    >
      <core-expandable-rich-text
        :content="props.data.description"
        text-size-class="text-sm"
      />
    </div>

    <ul class="container-d px-1 grid grid-cols-2 <sm:grid-cols-1 gap-1">
      <li
        v-for="entry in props.entries"
        :key="entry.id"
      >
        <thumbnails-education :data="entry" />
      </li>
    </ul>
  </div>
</template>
